import { tv } from "@utils/tw"
import { EditableText } from "eddev/blocks"
import { PropsWithChildren } from "react"
import { MediaLayoutOption, ResponsiveImageFragment } from "@generated-types"
import { ImageCaption } from "./ImageCaption"

type Props = PropsWithChildren<{
  image?: ResponsiveImageFragment
  layout: MediaLayoutOption
}>

export function MediaBlock(props: Props) {
  const hasImage = !!props.children
  if (!hasImage && !env.admin) {
    return null
  }

  const styles = createStyles({ layout: props.layout as any })

  return (
    <div className={styles.wrapper()}>
      <div className={styles.column()}>
        {props.children}
        <EditableText
          store="caption"
          as={ImageCaption}
          placeholder="Enter an optional caption"
          className={styles.caption()}
        />
      </div>
    </div>
  )
}

const createStyles = tv({
  slots: {
    wrapper: "md:grid-auto",
    column: "",
    caption: "",
  },
  variants: {
    layout: {
      full: {
        wrapper: "my-8",
        column: "md:col-span-12",
      },
      large: {
        wrapper: "grid-auto my-8",
        column: "col-span-12 md:col-1-10",
        caption: "!px-0",
      },
      inline: {
        wrapper: "grid-auto my-6",
        column: "col-span-12 md:col-6-6",
        caption: "!px-0",
      },
    },
  },
})
